module.exports = __webpack_public_path__ + "static/media/29ADMSPC6.ecad7dc3.jpg";